export default __webpack_public_path__ + "static/media/alert-icon.66771d84.svg";